import { createSelector } from 'reselect';

import { LOCATIONS_CAROUSEL_KEY } from './constants';

export const getLocationsCarouselState = createSelector(
    state => state[LOCATIONS_CAROUSEL_KEY],
    locations => locations
);
